import {Languages} from './languages';

export type SeoSettings = {
    title: string;
    description: string;
    keywords: string;
};

export type SeoLocations = 'login' | 'register';
export type SeoLocationSettings = Record<SeoLocations, SeoSettings>;

export const SEO_TEXTS: Record<Languages, SeoLocationSettings> = {
    en: {
        login: {
            title: 'amnis login: Your global business account #1',
            description:
                'Click here for the amnis login - the payment platform #1 for international transfers & foreign exchange transactions!',
            keywords: 'amnis treasury login, amnis login',
        },
        register: {
            title: 'amnis registration: Your global business account #1',
            description:
                'It only takes 30 seconds to create your amnis account and test the best solution for international payments.',
            keywords: 'amnis registration,amnis account',
        },
    },
    de: {
        login: {
            title: 'amnis login: Ihr Firmenkonto #1',
            description:
                "Hier geht's zum amnis Login - der Zahlungsplattform für internationale Überweisungen & Devisengeschäfte!",
            keywords: 'amnis treasury login, amnis login',
        },
        register: {
            title: 'amnis Registrierung: Ihr globales Firmenkonto #1',
            description:
                'In wenigen Minuten Ihren amnis Account erstellen und die beste Lösung für internationale Zahlungen testen.',
            keywords: 'amnis registrierung,amnis account erstellen',
        },
    },
    it: {
        login: {
            title: 'amnis login: il vostro conto aziendale n. 1',
            description:
                'Clicca qui per accedere ad amnis - la piattaforma di pagamento per bonifici internazionali e il cambio valuta!',
            keywords: 'amnis treasury login, amnis login',
        },
        register: {
            title: 'Registrazione amnis: Il vostro conto aziendale globale #1',
            description:
                'Bastano 30 secondi per creare un conto amnis e provare la soluzione migliore per pagamenti internazionali.',
            keywords: 'registrazione amnis,conto amnis',
        },
    },
    fr: {
        login: {
            title: "amnis login: votre compte d'entreprise #1 | amnis",
            description:
                'AMNIS Treasury Services: connectez-vous à la plateforme de paiement la plus rapide et la plus abordable de transferts internationaux!',
            keywords: 'amnis login, amnis treasury login',
        },
        register: {
            title: 'Créez votre compte amnis pour votre entreprise | amnis',
            description:
                'Inscrivez-vous et créez votre compte amnis en 30 secondes. La meilleure solution pour des paiements internationaux rapides et sécurisés.',
            keywords: "amnis créer un compte, amnis s'inscrire",
        },
    },
    pl: {
        login: {
            title: 'amnis login: Twoje globalne konto biznesowe #1',
            description:
                'Kliknij tutaj, aby uzyskać amnis login - platformę płatniczą #1 dla przelewów międzynarodowych i transakcji walutowych!',
            keywords: 'amnis treasury login, amnis login',
        },
        register: {
            title: 'Rejestracja amnis: Twoje globalne konto firmy #1',
            description:
                'Wystarczy 30 sekund, aby stworzyć swoje konto amnis i przetestować najlepsze rozwiązanie do płatności międzynarodowych.',
            keywords: 'rejestracja amnis,konto amnis',
        },
    },
    cs: {
        login: {
            title: 'amnis přihlášení: Váš globální firemní účet č. 1',
            description:
                'Klikněte zde pro přihlášení k amnis - platební platforma č. 1 pro mezinárodní převody a devizové transakce!',
            keywords: 'amnis treasury login, amnis přihlášení',
        },
        register: {
            title: 'Registrace amnis: Váš mezinárodní obchodní účet č. 1',
            description:
                'Vytvoření účtu amnis a vyzkoušení nejlepšího řešení pro mezinárodní platby trvá pouhých 30 sekund.',
            keywords: 'registrace amnis,účet amnis',
        },
    },
};
